import MUISwitch from '@mui/material/Switch';
import * as React from 'react';
import './index.scss';

export interface SwitchProps {
  toggleView: (value: boolean) => void;
  value: boolean;
}

export const Switch: React.FC<SwitchProps> = ({ toggleView, value }) => (
  <div className="Switch">
    <span className={value ? 'selected' : undefined}>2018</span>
    <MUISwitch
      checked={!value}
      onChange={event => toggleView(!event.target.checked)}
    />
    <span className={!value ? 'selected' : undefined}>2022</span>
  </div>
);
